import { render, staticRenderFns } from "./waterAffairs.vue?vue&type=template&id=23b0c074&scoped=true&"
import script from "./waterAffairs.vue?vue&type=script&lang=js&"
export * from "./waterAffairs.vue?vue&type=script&lang=js&"
import style0 from "./waterAffairs.vue?vue&type=style&index=0&id=23b0c074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b0c074",
  null
  
)

export default component.exports